import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  deptBydomain,
  desigByDept,
  desigByDomain,
} from "../../Services/getServices";
import { ssoRoleBydomain } from "../../Services/getServices";
import { ssoRoleBydept } from "../../Services/getServices";
// import SideBar from "./SideBar";
import { loader } from "../../redux/type";
// import { registerNewUser } from "../../Services/getServices";
import { pincodeList } from "../../Services/getServices";
import { localityList } from "../../Services/getServices";
import { districtList } from "../../Services/getServices";
import { domainList } from "../../Services/getServices";
// import { LoginUser } from "../../Services/authServices";
import { toast } from "react-toastify";
import Aawaas from "./../DomainPages/Aawas";
import OnlineMeasurementEMB from "./../DomainPages/OnlineMeasurementEMB";
import CitizensCentric from "./../DomainPages/CitizensCentric";
import Idli from "./../DomainPages/Idli";
import WaterBill from "./../DomainPages/WaterBill";
import OnlineBookingCommunity from "./../DomainPages/OnlineBookingCommunity";
import Bhoomi from "./../DomainPages/Bhoomi";
import Opd from "./../DomainPages/Opd";
import { adminUserDomainDetails } from "../../Services/postServices";

import AdminAawaas from "./AddAdminDomainPages/AdminAawaas";
import AdminBhoomi from "./AddAdminDomainPages/AdminBhoomi";
import AdminCitizenCentric from "./AddAdminDomainPages/AdminCitizenCentric";
import AdminIdli from "./AddAdminDomainPages/AdminIdli";
import AdminOnlineBookingCommunity from "./AddAdminDomainPages/AdminOnlineBookingCommunity";
import AdminOpd from "./AddAdminDomainPages/AdminOpd";
import AdminOnlineMeasurementEMB from "./AddAdminDomainPages/AdminOnlineMeasurementEMB";
import AdminWaterBill from "./AddAdminDomainPages/AdminWaterBill";
import { userType } from "../../Services/postServices";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';



const AddAdmin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = JSON.parse(localStorage.getItem("user"));
//   console.log("DATATATA=", userData?.user?.id);
  // const id=userData?.user?.id

  // const id=userData?.domainCodesByUserId[0]?.userId

  // const id=userData?.domainCodesByUserId[0]?.userId;
  const id = userData?.user?.userId;
  const mobileNo1=userData?.user?.mobile
  const emailId=userData?.user?.emailId


  const mobNum = localStorage.getItem("moblie");

  var [tit, setTit] = useState("");
  var [firstName, setFirstName] = useState("");
  var [middleName, setMiddleName] = useState("");
  var [lastName, setLastName] = useState("");
  var [fatherName, setFatherName] = useState("");
  var [aadhaarNo, setAadhaarNo] = useState("");
  var [mobileNo, setMobileNo] = useState("");
  var [panNo, setPanNo] = useState("");
  var [email, setEmail] = useState("");
  var [gender, setGender] = useState("");
  var [dob, setDob] = useState("");
  var [consumerId, setConsumerId] = useState("");
  var [property, setProperty] = useState("");
  var [createUser, setCreateUser] = useState("");
  var [password, setPassword] = useState("");
  var [pincode, setPincode] = useState("");
  var [district, setDistrict] = useState("");
  var [locality, setLocality] = useState("");

  var [domainListArr, setDomainListArr] = useState([]);
  var [domainCodeS, setDomainCodeS] = useState("");
var[domainDet,setDomainDet]=useState([]);
var[rolesList,setRolesList]=useState([]);

  useEffect(() => {
    domain();
    // deptByDomainName();
    // ssoRoleByDomainName();
    // ssoRoleBydeptId();
    // desigByDomainName();
    // desigByDeptId();
  }, []);

  

  function domain() {
     dispatch({ type: loader.startLoader });
        // let userId=1791
        let req = {
          "userId":id,
          "mobileNo":mobileNo1,
          "email":emailId,
           
       }
    
        adminUserDomainDetails(req, (res) => {
          dispatch({ type: loader.stopLoader });
          if (res?.data?.status) {
            setDomainDet(res?.data?.result?.domainList);
            console.log("domain details=",res);
          } else {
            console.log(res);
          }
        });
  }

  

  function deptByDomainName(domainCo) {
    deptBydomain(domainCo, (res) => {
      if (res.status) {
      } else {
      }
    });
  }
  function ssoRoleByDomainName(domainCo) {
    ssoRoleBydomain(domainCo, (res) => {
      if (res?.data?.status) {
        setRolesList(res?.data?.result);
        console.log("roless", res?.data?.result);
      } else {
      }
    });
  }

  function ssoRoleBydeptId() {
    ssoRoleBydept("26", (res) => {
      if (res.status) {
      } else {
      }
    });
  }

  function desigByDomainName(domainCo) {
    desigByDomain(domainCo, (res) => {
      if (res.status) {
      } else {
      }
    });
  }

  function desigByDeptId() {
    desigByDept("54", (res) => {
      if (res.status) {
      } else {
      }
    });
  }
  console.log("roless", rolesList);

  const renderForm = () => {
    console.log("DOMAINCODE", domainCodeS);

    switch (domainCodeS) {
      case "CS":
        return <AdminCitizenCentric    />;
      case "AA":
        return <AdminAawaas  data={{  domainCode: domainCodeS,  }} />;
      case "BH":
        return <AdminBhoomi data={{  domainCode: domainCodeS,  }}/>;
      case "MS":
        return <AdminOnlineMeasurementEMB />;
      case "WB":
        return <AdminWaterBill  data={{  domainCode: domainCodeS,  }} />;
      case "OP":
        return <AdminOpd />;
      case "ID":
        return <AdminIdli />;
      case "BO":
        return <AdminOnlineBookingCommunity />;
      case "LM":
        return <h1>LIMS !</h1>;
      case "NP":
        return <h1>New Payroll !</h1>;
      case "VL":
        return <h1>VLMS !</h1>;
      case "EW":
        return <h1>Expression of willingness !</h1>;
      default:
        return <h5>Please Select Domain</h5>;
    }
  };



  return (
    <>
      <div className="card shadow myprofileCard ">
        <div className="card-body overFlow p-md-3">
          <h4 className="h2_heading"> Add Admin User</h4>

          <div className="row justify-content-around ">
            <div className="col-12">
              <div className="form-outline mb-3">
                <label className="form-label" for="id">
                  Domain Name:
                </label>

                <select
                  class="form-control form-select"
                  onChange={(e) => {
                    setDomainCodeS(e.target.value);
                    desigByDomainName(e.target.value);
                    ssoRoleByDomainName(e.target.value);
                    deptByDomainName(e.target.value);
                    
                  }}
                >
                  <option value="0">Select Domain </option>

                  {domainDet.map((val) => {
                    return (
                      <option key={val} value={val.domainCode}>
                        {val.domainName}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </div>

        

          {/* <Aawaas/> */}
          {/* <OnlineMeasurementEMB/> */}
          {/* <CitizensCentric/> */}
          {/* <Idli/> */}
          {/* <WaterBill/> */}
          {/* <OnlineBookingCommunity/> */}

          {renderForm()}
        </div>
      </div>
    </>
  );
};
export default AddAdmin;
